module.exports = __webpack_public_path__ + "shop-price.svg?09eceb09121ca1601d04b5e41f132008";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shop-price.svg
// module id = 323
// module chunks = 2